import { ActivityInformationDisplayProps } from './utils/types';
import {
  useActivityInformationHeaders,
  useActivityInformationRenderSwitches
} from './utils/useActivityInformationRenderSwitches';
import { Box } from '@chakra-ui/react';
import { SimpleTabs } from '@invara-dev/react-base';
import { ActivityInformationCompanyDisplay } from './displays/activityInformationCompanyDisplay';
import { HotelBookingType } from '../../../globalModels/common/hotelBookingType.ts';
import { ActivityInformationTravellerDisplay } from './displays/activityInformationTravellerDisplay';
import { ActivityInformationHotelDisplay } from './displays/activityInformationHotelDisplay';

type Props = ActivityInformationDisplayProps & {};

export const ActivityInformationTabs = (props: Props) => {
  const renderSwitches = useActivityInformationRenderSwitches(props);
  const headers = useActivityInformationHeaders(renderSwitches);

  if (headers.length == 0 || headers.every((x) => x.disabled)) {
    return <Box>No activity data entered.</Box>;
  }

  return (
    <SimpleTabs tabNames={headers} size={'sm'}>
      {renderSwitches.renderPolicies && props.companyId && props.hotelBookingType != HotelBookingType.Personal && (
        <ActivityInformationCompanyDisplay companyId={props.companyId} activityId={props.activityId} />
      )}
      {renderSwitches.renderTravellers && (
        <ActivityInformationTravellerDisplay
          companyId={props.companyId}
          requestedById={props.requestedById}
          approvedBookerId={props.approvedBookerId}
          travellerIds={props.travellerIds ?? []}
          activityId={props.activityId}
        />
      )}
      {renderSwitches.renderHotel && <ActivityInformationHotelDisplay hotelIds={props.hotelIds ?? []} />}
    </SimpleTabs>
  );
};
